import { TColumnName, TDataset } from "../../types";
import ColumnUtils from "../../utils/ColumnUtils";
import RowUtils from "../../utils/RowUtils";
import { put, select } from "typed-redux-saga";
import { workerActions } from "../../reducers/worker.slice";
import { generateScoresCacheKey } from "../../utils/utils";
import {
  selectLogisticRegression,
  selectSilhouetteScoreForCacheKey,
} from "../../selectors/worker.selector";
import { TRootState } from "../../store/create-store";
import { setStatus } from "../../dom-utils";
import { selectLeftPanelState, selectRootState } from "../../selectors";
import { isNumber } from "util";

function* generateCategoricalScores() {
  const { rows } = yield* select(selectRootState);
  const { selectedDataset, selectedMethod, selectedColumn } = yield* select(
    selectLeftPanelState
  );

  if (!selectedDataset || !selectedMethod || !selectedColumn) {
    setStatus("No method or column selected");
    return;
  }

  const key = generateScoresCacheKey(
    selectedDataset,
    selectedMethod,
    selectedColumn
  );

  const logitRegression = yield* select((state: TRootState) =>
    selectLogisticRegression(state, key)
  );
  const silhouetteScore = yield* select((state: TRootState) =>
    selectSilhouetteScoreForCacheKey(state, key)
  );

  if (logitRegression && silhouetteScore) {
    return;
  }

  const methodNameX = selectedMethod;
  const { Y: methodNameY, Z: methodNameZ } =
    ColumnUtils.getMethodColumnYZNames(selectedMethod);

  const labelColumn: string[] = []; // ['Male', 'Female', 'Male', 'Male', ...]
  const labelSet = new Set(); // {'Male', 'Female'}

  const data = rows.map((row) => {
    const v = RowUtils.getValue(row, selectedColumn);
    labelSet.add(v);
    labelColumn.push(v ?? "");

    const x = RowUtils.getValueAsNumber(row, methodNameX);
    const y = RowUtils.getValueAsNumber(row, methodNameY);
    const z = RowUtils.getValueAsNumber(row, methodNameZ);

    return [x, y, z];
  });

  const labelsArray = Array.from(labelSet.values()); // ['Male', 'Female']
  const labelsAsNumbers: number[] = labelsArray.map((l, i) => i); // [0, 1]
  const labelsColumnAsNumbers: number[] = [];

  const trainingData = data.map((datum, i) => {
    const label = labelColumn[i]; // Male
    labelsColumnAsNumbers.push(labelsArray.indexOf(label));
    return [...datum, labelsArray.indexOf(label)];
  });

  if (!logitRegression) {
    yield* put(
      workerActions.logisticRegression({
        trainingData,
        labels: labelsAsNumbers,
        key,
      })
    );
  }

  if (typeof silhouetteScore !== "number") {
    yield* put(
      workerActions.silhouetteScore({
        key,
        data,
        labels: labelsColumnAsNumbers,
      })
    );
  }
}

export default generateCategoricalScores;
